<template>
	<div class="exercise analysis">
		<el-row :gutter="20">
			<el-col :span="24">
				<div class="card">
					<h5>Records</h5>
					<ExerciseTable :id="id" :event="event"></ExerciseTable>
				</div>
			</el-col>
			<!-- <el-col :span="12">
				<div class="card">
					<h5>Graph</h5>
				</div>
			</el-col> -->
		</el-row>
	</div>
</template>

<script>
import ExerciseAnalysis from '.'
import ExerciseTable from './Table'

export default {
	name: 'patient-exercise-card-analysis',
	extends: ExerciseAnalysis,

	components: {
		ExerciseTable
	}
}
</script>

<style lang="scss" scoped>
@import "../../component/table/style/analysis.scss";
</style>
